import { Button } from 'src/components/Button/Button.component';
import { ModalFooterProps } from 'src/components/Modal/partials/ModalFooter/ModalFooterDefault.component';
import { ModalFooterRoot } from 'src/components/Modal/partials/ModalFooter/style/ModalFooterDefault.style';
import Translate from 'src/components/Translate/Translate.component';
import React from 'react';
import { useFormContext } from 'react-hook-form';

export type IncorrectDataModalFooterProps = ModalFooterProps & {
  applyForm: () => void;
};

const IncorrectDataModalFooter: React.FC<IncorrectDataModalFooterProps> = ({
  applyForm,
}) => {
  const { handleSubmit, formState } = useFormContext();
  return (
    <ModalFooterRoot>
      <Button
        sizeOnDesktop="medium"
        onClick={handleSubmit(applyForm)}
        disabled={!formState.isValid}
      >
        <Translate id="lbl.confirm" />
      </Button>
    </ModalFooterRoot>
  );
};

export default IncorrectDataModalFooter;
